import React, { PropTypes } from 'react';
import GrayPanel from '../../components/GrayPanel';
import { PanelStyle } from '../../constants';
import Select from 'react-select';
import DatePicker from 'react-bootstrap-date-picker';

/**
 * Rodzaj zamierzenia inwestycyjnego Kontener
 */

const polishMonthLabels = [
  'Styczeń',
  'Luty',
  'Marzec',
  'Kwiecień',
  'Maj',
  'Czerwiec',
  'Lipiec',
  'Sierpień',
  'Wrzesień',
  'Październik',
  'Listopad',
  'Grudzień',
];
const polishDayLabels = ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'So'];

const typeList = ['Select', 'textarea', 'DatePicker'];

class Decision extends React.Component {
  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  state = {
    tag: 'input',
  };

  render() {
    const {
      leftCol,
      labelCol,
      inputCol,
      inputStyle,
      errorSpanStyle,
      rightCol,
      labelStyle,
      rowStyle,
      type,
    } = PanelStyle;

    const newDate = new Date().toISOString();

    return (
      <GrayPanel title={this.props.title}>
        {this.props.explain_text ? this.props.explain_text() : null}

        {Object.keys(this.props.formDict).map((v, i) => {
          const isEditable =
            this.props.formDict[v].editable && this.props.formDict[v].editable === true;
          const InputComponent =
            Object.keys(this.props.formDict).indexOf('type') &&
            this.props.formDict.type === 'textarea';
          // const TagName =
          //   Object.keys(this.props.formDict[v]).indexOf('type') &&
          //   this.props.formDict[v].type === 'textarea' ?
          //   'textarea' :
          //     Object.keys(this.props.formDict[v]).indexOf('type') &&
          //     this.props.formDict[v].type === 'Select' ?
          //     'Select'
          //       : 'input';
          const TagName =
            Object.keys(this.props.formDict[v]).indexOf('type') &&
            typeList.includes(this.props.formDict[v].type) ?
            this.props.formDict[v].type
                : 'input';
          return (
            <div className="row mobile-row" key={i} style={rowStyle}>
              <div className={this.props.leftCol ? this.props.leftCol : leftCol} />
              <div className={this.props.labelCol ? this.props.labelCol : labelCol}>
                <label style={labelStyle}>{this.props.formDict[v].label}</label>
              </div>
              <div className={this.props.inputCol ? this.props.inputCol : inputCol}>
                {isEditable ? (
                  TagName === 'Select' ?
                    <Select
                      placeholder="Wybierz z listy..."
                      name="option"
                      value={this.props.data[v] ? this.props.data[v] : ''}
                      options={this.props.formDict[v].options}
                      clearable={false}
                      // onInputChange={this.inputAdressChange}
                      onChange={this.props.onChangeSelect}
                      style={{
                        borderColor:
                        Object.keys(this.props.errors).indexOf(v) > -1 &&
                        this.props.errors[v] !== null &&
                        this.props.errors[v].length > 0
                          ? 'red'
                          : '#ccc',
                      }}
                    />
                    : TagName === 'DatePicker' ?
                      <DatePicker
                        onChange={this.props.onChangeDate}
                        value={this.props.data[v] ? this.props.data[v] : ''}
                        placeholder="DD-MM-YYYY"
                        monthLabels={polishMonthLabels}
                        dayLabels={polishDayLabels}
                        minDate={newDate}
                        style={{
                          borderColor:
                          Object.keys(this.props.errors).indexOf(v) > -1 &&
                          this.props.errors[v] !== null &&
                          this.props.errors[v].length > 0
                            ? 'red'
                            : '#ccc',
                        }}
                      />
                    : <TagName
                      type={this.props.formDict[v].type ? this.props.formDict[v].type : type}
                      name={v}
                      style={{
                        ...inputStyle,
                        borderColor:
                          Object.keys(this.props.errors).indexOf(v) > -1 &&
                          this.props.errors[v] !== null &&
                          this.props.errors[v].length > 0
                            ? 'red'
                            : '#ccc',
                      }}
                      className="form-control"
                      value={this.props.data[v] ? this.props.data[v] : ''}
                      onChange={this.props.onChange}
                      placeholder={this.props.formDict[v].placeholder ? this.props.formDict[v].placeholder : ""}
                    />
                ) : (
                  <input
                    name={v}
                    style={{
                      ...inputStyle,
                      borderColor:
                        Object.keys(this.props.errors).indexOf(v) > -1 &&
                        this.props.errors[v] !== null &&
                        this.props.errors[v].length > 0
                          ? 'red'
                          : '#ccc',
                    }}
                    className="form-control"
                    value={this.props.data[v] ? this.props.data[v] : ''}
                    disabled
                  />
                )}

                {/* RENDER ERROS IN SPAN */}
                {Object.keys(this.props.errors).indexOf(v) > -1 &&
                this.props.errors[v] !== null &&
                this.props.errors[v].length > 0
                  ? this.props.errors[v].map((val, index) => (
                    <span key={index} style={errorSpanStyle}>
                      {val}
                    </span>
                    ))
                  : null}
              </div>
              <div className={this.props.rightCol ? this.props.rightCol : rightCol} />
            </div>
          );
        })}
        {this.props.children}
      </GrayPanel>
    );
  }
}

Decision.PropTypes = {
  children: PropTypes.Object,
  rightCol: PropTypes.Object,
  labelCol: PropTypes.Object,
  leftCol: PropTypes.Object,
  explain_text: PropTypes.func,
  title: PropTypes.string,
  formDict: PropTypes.Object,
};

export default Decision;



// WEBPACK FOOTER //
// src/containers/Decision/index.jsx